export default "__VITE_ASSET__OeaPKyWP__"